(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-clientes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-lf-clientes]').forEach(function (seccion) {
      var videos = seccion.querySelectorAll('[data-lf-video]');
      if (!videos.length) return;
      videos.forEach(function (v) {
        var item = v.closest('.lf-cli__item');
        var boton = item.querySelector('[data-lf-play]');
        if (reducir) { item.classList.add('lf-cli--pausado'); }
        if (boton) boton.addEventListener('click', function () { v.play(); item.classList.remove('lf-cli--pausado'); });
        v.addEventListener('play', function () { item.classList.remove('lf-cli--pausado'); });
      });
      if (reducir || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.intersectionRatio > 0.5) { v.play().catch(function () { v.closest('.lf-cli__item').classList.add('lf-cli--pausado'); }); }
          else { v.pause(); }
        });
      }, { threshold: [0, 0.5, 1] });
      videos.forEach(function (v) { obs.observe(v); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
